import { MatMenuTrigger } from '@angular/material/menu';

export const CUSTOM_SET_FILTER_CHECKBOX_GROUP_CSS_CLASS = 'custom-set-filter-checkbox-group';

export const CUSTOM_FILTER_ENGINE_OVERLAY_PANEL_CSS_CLASS = 'iot-platform-ui-filter-engine-field-trigger-menu';
export const CUSTOM_FILTER_ENGINE_DATE_PICKER_OVERLAY_PANEL_CSS_CLASS = 'mat-datepicker-popup';

/**
 * Get the menu panel element for a specific MatMenuTrigger instance
 */
export function getMenuTriggerElement(menuRef: MatMenuTrigger | undefined): HTMLElement | null {
  const panelId = menuRef?.menu?.panelId;
  if (panelId) {
    // Get the trigger element (button that opens this specific menu)
    return document.querySelector(`[aria-controls="${panelId}"]`);
  }
  return null;
}

/**
 * Get the menu panel element for a specific MatMenuTrigger instance
 */
export function getMenuPanelElement(menuRef: MatMenuTrigger | undefined): HTMLElement | null {
  const panelId = menuRef?.menu?.panelId;
  if (panelId) {
    // Get the menu panel element for this specific menu instance
    return document.getElementById(panelId);
  }
  return null;
}

/**
 * Check if a mouse event occurred outside the specified element's boundaries
 */
export function isClickOutsideElement(event: MouseEvent, element: HTMLElement): boolean {
  const rect = element.getBoundingClientRect();
  const { clientX: mouseX, clientY: mouseY } = event;

  return mouseX < rect.left || mouseX > rect.right || mouseY < rect.top || mouseY > rect.bottom;
}

/**
 * Recursively check if an element or any of its parents has the specified CSS class
 */
export function hasParentWithClass(element: HTMLElement | null, className: string): boolean {
  if (!element) {
    return false;
  }

  if (element.classList?.contains(className)) {
    return true;
  }

  return hasParentWithClass(element.parentElement, className);
}
